/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPointActionReqVo
 */
export interface UserPointActionReqVo {
    /**
     * 用户积分数据编号
     * @type {number}
     * @memberof UserPointActionReqVo
     */
    id: number;
    /**
     * 积分数量
     * @type {number}
     * @memberof UserPointActionReqVo
     */
    amount: number;
}

/**
 * Check if a given object implements the UserPointActionReqVo interface.
 */
export function instanceOfUserPointActionReqVo(value: object): value is UserPointActionReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function UserPointActionReqVoFromJSON(json: any): UserPointActionReqVo {
    return UserPointActionReqVoFromJSONTyped(json, false);
}

export function UserPointActionReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPointActionReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount': json['amount'],
    };
}

export function UserPointActionReqVoToJSON(json: any): UserPointActionReqVo {
    return UserPointActionReqVoToJSONTyped(json, false);
}

export function UserPointActionReqVoToJSONTyped(value?: UserPointActionReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
    };
}

